const primary = '#393f55' ;//dark blue, header
// const secondary = '#49daf7';//light blue
const secondary = '#ff6600';

export const PALETTE = {
    White: 'white',
    Primary: primary,//header
    Secondary: secondary,//subheader
    Header: {
        TextColor: 'white'
    },
    UI: {
        Images:{
            BackgroundColor: '#e4e7f2',
        },
        TablesHeader: {
            BackgroundColor: '#e4e7f2'
        },
        RichTextEditor: {
            HighLight: {
                Background: '#f1f1f1'
            }
        },
        InputText: {
            AdornmentButton: {
                BackgroundColor: '#8d92aa'
            },
            TextColor: 'black',
            ClearIconColor: 'white'
        },
        Upload: {
            BorderColor: '#258900',
            ButtonColor: '#258900'
        },
        Buttons: {
            Background: primary,
            HoveredBackground: "#ff6600",
            FillHovered: secondary,
            Tabbed:{
                Selected:{
                    Background:secondary,
                    HoveredBackground: "#fcdbbb",
                },
                Unselected:{
                    Background: '#d53232',
                    HoveredBackground: "#fcdbbb",
                },
                Fill: '#fae5e5',
                FillHovered: secondary,
            }
        }
    },
    Contacts: {
        List: {
            SelectedContact: {
                BackGroundColor: "#fcdbbb",
                HoveredBackGroundColor: "#e4e7f2"
            },
            HoveredBackGroundColor: '#e4e7f2'

        }
    },
    AuthLockPrimaryColor: '0000ff',
    AppBarBackgroundColor: primary,
    Chat: {
        Background: '#E4E7F2',
        MyMessageBackground: '#fcdbbb',
        OtherMessageBackground: '#FFFFFF',
        MessageTextColor: '#000000',
        TimeStampColor: '#8D92AA',
    },
    PostSent: {
        Chart: {
            YesColor: '#008000',
            NoColor: '#FF0000',
            UnansweredColor: '#808080'
        }
    },
    Drawer: {
        Header: {
            BackgroundColor: '#c0c5d8'
        },
        Body: {
            // BackgroundColor: '#eff1f7'
            BackgroundColor: '#484b58f5',
            FontColor: '#FFF'
        }
    }
};